export default {
    SUBSCRIBE_MODAL: {
        component: 'subscribe-modal',
        level: 1,
    },

    GENERIC_CONFIRMATION: {
        component: 'generic-confirmation-modal',
        level: 2,
    },

    GENERIC_INFO: {
        component: 'generic-info-modal',
        level: 2,
    },

    FOLLOWERS_MODAL: {
        component: 'followers-modal',
        level: 2,
    },
    FOLLOWINGS_MODAL: {
        component: 'followings-modal',
        level: 2,
    },
    LIKES_MODAL: {
        component: 'likes-modal',
        level: 2,
    },

    FLAG_CONTENT: {
        component: 'flag-content-modal',
        level: 3,
    },

    SELECT_OPTION: {
        component: 'select-option-modal',
        level: 10,
    },

    ACCEPT_COOKIES: {
        component: 'accept-cookies-modal',
        level: 1,
    },

    CREATE_MEDIA_VAULT_ALBUM: {
        component: 'create-media-vault-album-modal',
        level: 1,
    },
    UPDATE_MEDIA_VAULT_ALBUM: {
        component: 'update-media-vault-album-modal',
        level: 1,
    },
    SELECT_MEDIA_VAULT_ALBUM: {
        component: 'select-media-vault-album-modal',
        level: 1,
    },
    SELECT_MEDIA_VAULT_FILES: {
        component: 'select-media-vault-files-modal',
        level: 1,
    },

    CREATOR_MENTION_DROPDOWN: {
        component: 'creator-mention-dropdown-modal',
        level: 10,
    },

    PROFILE_LEFT_PANEL: {
        component: 'profile-left-panel',
        level: 1,
    },
    LEGAL_LEFT_PANEL: {
        component: 'legal-left-panel',
        level: 1,
    },
    
    GDPR_REQUEST: {
        component: 'gdpr-request-modal',
        level: 1,
    },
}
